module.exports = __webpack_public_path__ + "img/mastercard.a25f9bd5.png";